import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('sid-footer-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {

        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        const scrollAnim = gsap.timeline({
            scrollTrigger: {
                trigger: '#sid-footer-container',
                start: 'top 90%',
                scrub: 0.6, // process by scrolling
                // markers: true, // for DEBUG
                toggleActions: 'restart none none none',
            },
        });

        scrollAnim
            .to('.sid-footer-head', {
                y: '41%',
            });

        // ScrollTrigger.create({
        //     trigger: '#sid-footer-container',
        //     start: 'top bottom',
        //     endTrigger: '#sid-footer-container',
        //     end: 'bottom 50%+=100px',
        //     onToggle: (self) => console.log('toggled, isActive:', self.isActive),
        //     onUpdate: (self) => {
        //         console.log(
        //             'progress:',
        //             self.progress.toFixed(3),
        //             'direction:',
        //             self.direction,
        //             'velocity',
        //             self.getVelocity(),
        //         );
        //     },
        // });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

    },

    beforeDestroy() {
    },
});
